<template>
    <v-dialog v-model="dialog" width="500" persistent scrollable>
        <template v-slot:activator="{ on, attrs }">
            <v-btn class="mr-2" small color="primary" rounded v-bind="attrs" v-on="on">
                <v-icon left>mdi-pencil-box-multiple</v-icon>
                Manage Roles
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                Manage {{ [item.fname, item.lname].join(' ') }} Roles
            </v-card-title>
            <feathers-vuex-find service="bh-roles" :query="{}" watch="query">
                <v-card-text slot-scope="{ items: Roles }">
                    <v-select v-model="rolesValue" :items="Roles" item-text="name" item-value="id" chips deletable-chips label="Groups" multiple></v-select>
                </v-card-text>
            </feathers-vuex-find>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-if="!loading" small color="red" text @click="dialog = false">Cancel</v-btn>
                <v-btn small color="primary" text @click="save" :loading="loading">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        item: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            dialog: false,
            loading: false,
            rolesValue: this.item.roles.map(i => i.role.id)
        };
    },
    methods: {
        async save() {
            try {
                this.loading = true;
                await Promise.all(this.item.roles.map(i => {
                    return this.removeRoles([i.id]);
                }));
                await Promise.all(this.rolesValue.map(i => {
                    return this.createNewRoles({
                        user_id: this.item.id,
                        role_id: i
                    });
                }));
                await this.findUser({ query: { id: this.item.id, $populate: true } });
                this.dialog = false;
                this.$emit('success');
            } catch(err) {
                this.$emit('error', err);
            } finally {
                this.loading = false;
            }
            // console.log(this.rolesValue);
        },
        ...mapActions('bh-user-roles', { createNewRoles: 'create', removeRoles: 'remove' }),
        ...mapActions('users', { findUser: 'find' })
    }
}; 
</script>